import Vue from "vue";
import Vuex from "vuex";
import Activity from "../../models/Activity";
import Classification from "../../utils/classification";
const firebase = require("../../../firebase.config.js");

Vue.use(Vuex);

const ActivitiesModule = {
  namespaced: true,
  state: {
    activity: new Activity(),
    originalActivity: new Activity(),
    thisActivity: new Activity(),
    allActivities: [],
    drafts: []
  },
  getters: {
    getAllActivities(state) {
      return state.allActivities;
    },
    getMyActivities(state) {
      return state.allActivities.filter(
        x => x._userId === firebase.auth().currentUser.uid
      );
    },
    getMyFavorites(state, rootGetters, rootState) {
      return state.allActivities.filter(x =>
        rootState.user.user.data.likes.includes(x.id)
      );
    },
    getThisActivity(state) {
      return state.thisActivity;
    },
    getAllDrafts(state) {
      return state.drafts;
    },
    getActivity(state) {
      return state.activity;
    },
    getMediasToUpload(state) {
      return state.mediasToUpload;
    },
    getOriginalActivity(state) {
      return state.originalActivity;
    }
  },
  actions: {
    restoreData({ commit }, old) {
      commit("SET_THIS_ACTIVITY", Object.assign(new Activity(), old));
    },
    resetForm({ state }) {
      state.activity = new Activity();
    },
    fetchDraftActivities({ commit, rootGetters }) {
      firebase.activitiesCollection
        .orderBy("_createdOn", "desc")
        .where("_disabled", "==", false)
        .where("_draft", "==", true)
        .where("_userId", "==", rootGetters["user/getUser"].data.uid)
        .onSnapshot(querySnapshot => {
          let activitiesArray = [];
          querySnapshot.forEach(activity => {
            const post = Object.assign(new Activity(), activity.data());
            post.id = activity.id;
            post.mainMedia = "";
            if (post.defaultCover === "custom") {
              if (post.cover) {
                const storageRef = firebase.storage.ref(post.cover);
                storageRef.getDownloadURL().then(url => {
                  post.mainMedia = url;
                });
              }
            }
            if (post.defaultCover && post.defaultCover !== "custom") {
              const storageRef = firebase.storage.ref(post.defaultCover);
              storageRef.getDownloadURL().then(url => {
                post.mainMedia = url;
              });
            }

            activitiesArray.push(post);
          });
          commit("SET_DRAFTS", activitiesArray);
        });
    },
    fetchActivities({ commit, state }) {
      firebase.activitiesCollection
        .orderBy("_createdOn", "desc")
        .where("_disabled", "==", false)
        .where("_draft", "==", false)
        .onSnapshot(querySnapshot => {
          let activitiesArray = [];
          querySnapshot.docChanges().forEach(change => {
            if (change.type === "added") {
              const post = Object.assign(new Activity(), change.doc.data());
              post.id = change.doc.id;
              post.mainMedia = "";
              if (post.cover) {
                const storageRef = firebase.storage.ref(post.cover);
                storageRef.getDownloadURL().then(url => {
                  post.mainMedia = url;
                });
              } else if (post.defaultCover) {
                const storageRef = firebase.storage.ref(post.defaultCover);
                storageRef.getDownloadURL().then(url => {
                  post.mainMedia = url;
                });
              }

              activitiesArray.push(post);
              commit("SET_ACTIVITIES", activitiesArray);
            }
            if (change.type === "modified") {
              const post = Object.assign(new Activity(), change.doc.data());
              post.id = change.doc.id;
              for (const activity of state.allActivities) {
                if (activity.id === post.id) {
                  activity.likes = post.likes;
                }
              }
            }
          });
        });
    },
    fetchActivity({ commit }, id) {
      firebase.activitiesCollection.doc(id).onSnapshot(querySnapshot => {
        const doc = Object.assign(new Activity(), querySnapshot.data());
        doc.id = id;
        if (doc) {
          doc.mediaPdf = [];
          doc.mediaImg = [];
          doc.mediaVid = [];
          doc.allMedia = [];

          for (const media of doc.medias) {
            const storageRef = firebase.storage.ref(media);
            storageRef.getDownloadURL().then(url => {
              if (media.slice(media.lastIndexOf(".")).includes("pdf")) {
                doc.mediaPdf.push({ url: url, fileName: media });
              } else if (media.slice(media.lastIndexOf(".")).includes("mp4")) {
                doc.mediaVid.push({ url: url, fileName: media });
              } else {
                doc.mediaImg.push({ url: url, fileName: media });
              }

              doc.allMedia.push({ url: url, fileName: media, fullPath: media });
            });
          }
          doc.isMine = false;

          if (doc.userId === firebase.auth().currentUser.uid) {
            doc.isMine = true;
          }

          commit("SET_THIS_ACTIVITY", doc);
          commit("SET_ORIGINAL_ACTIVITY", doc);
        }
      });
    },
    fetchDraft({ commit }, id) {
      firebase.activitiesCollection.doc(id).onSnapshot(querySnapshot => {
        const doc = Object.assign(new Activity(), querySnapshot.data());
        doc.id = id;
        if (doc) {
          doc.mediaPdf = [];
          doc.mediaImg = [];
          doc.mediaVid = [];
          doc.mediaCover = null;
          doc.allMedia = [];
          if (doc.cover) {
            const storageRefCover = firebase.storage.ref(doc.cover);
            storageRefCover.getDownloadURL().then(url => {
              if (url) {
                doc.mediaCover = { imageUrl: url };
              }
            });
          }

          if (doc.cover) {
            const storageRefCover = firebase.storage.ref(doc.cover);
            storageRefCover.getDownloadURL().then(url => {
              if (url) {
                doc.mediaCover = { imageUrl: url };
              }
            });
          }

          for (const media of doc.medias) {
            const storageRef = firebase.storage.ref(media);
            storageRef.getDownloadURL().then(url => {
              if (media.slice(media.lastIndexOf(".")).includes("pdf")) {
                doc.mediaPdf.push({ url: url, fileName: media });
              } else if (media.slice(media.lastIndexOf(".")).includes("mp4")) {
                doc.mediaVid.push({ url: url, fileName: media });
              } else {
                doc.mediaImg.push({ url: url, fileName: media });
              }

              doc.allMedia.push({
                url: url,
                imageUrl: url,
                fileName: media,
                fullPath: media
              });
            });
          }
          doc.isMine = false;

          if (doc.userId === firebase.auth().currentUser.uid) {
            doc.isMine = true;
          }

          commit("SET_ACTIVITY", doc);
          commit("SET_ORIGINAL_ACTIVITY", doc);
        }
      });
    },
    validateStep1({ state, dispatch }, customCover) {
      if (customCover) {
        dispatch("upload/addCoverToUpload", state.activity.cover, {
          root: true
        });
      }
      dispatch("upload/addMediasToUpload", state.activity.allMedia, {
        root: true
      });
    },
    validateStep2({ state }, payload) {
      state.activity.etapes = payload.etapes;
      state.activity.moyensMesure = payload.moyensMesure;
      state.activity.precautions = payload.precautions;
      state.activity.gestionCapicitesTransfert =
        payload.gestionCapicitesTransfert;
      state.activity.cadreTheorique = payload.cadreTheorique;
    },
    validateStep3({ state }, payload) {
      const classification = Classification.getClassificationBySources(
        payload.sourcesBibliographique
      );

      state.activity.classification = classification;
      state.activity.sourcesBibliographique = payload.sourcesBibliographique;
      state.activity.terms = payload.terms;
    },
    // eslint-disable-next-line no-unused-vars
    async addActivity({ state, rootGetters }) {
      state.activity.cover = rootGetters["upload/getCoverUploaded"]
        ? rootGetters["upload/getCoverUploaded"]
        : "";

      state.activity.medias = rootGetters["upload/getMediasUploaded"];
      state.activity.titreUpper = state.activity.titre
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "")
        .toUpperCase();
      state.activity.descriptionUpper = state.activity.description
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "")
        .toUpperCase();
      //state.activity.proceduresUtiliseesUpper = state.activity.proceduresUtilisees.normalize("NFD").replace(/\p{Diacritic}/gu, "").toUpperCase();
      //state.activity.fonctionsCognitivesUpper = state.activity.fonctionsCognitives.normalize("NFD").replace(/\p{Diacritic}/gu, "").toUpperCase();

      let libelleAge = ["Enfants"];

      if (
        state.activity.age === "3 à 6 ans" ||
        state.activity.age === "7 à 10 ans"
      ) {
        libelleAge = ["Enfants"];
      } else if (
        state.activity.age === "11 à 13 ans" ||
        state.activity.age === "14 à 17 ans"
      ) {
        libelleAge = ["Adolescents"];
      } else if (
        state.activity.age === "18 à 25 ans" ||
        state.activity.age === "26 à 40 ans"
      ) {
        libelleAge = ["Adultes jeunes"];
      } else if (state.activity.age === "41 à 65 ans") {
        libelleAge = ["Adultes d'âge moyen"];
      } else if (
        state.activity.age === "66 à 80 ans" ||
        state.activity.age === "81 ans et plus"
      ) {
        libelleAge = ["Adultes âgés"];
      } else if (state.activity.age === "18 ans et plus") {
        libelleAge = ["Adultes jeunes", "Adultes d'âge moyen", "Adultes âgés"];
      }

      state.activity.ageLibelle = libelleAge;
      state.activity.tags = [
        ...state.activity.proceduresUtilisees,
        state.activity.classification,
        state.activity.difficulte,
        ...state.activity.fonctionsCognitives,
        state.activity.typeIntervention,
        ...libelleAge
      ];

      delete state.activity._allMedia;
      delete state.activity.mediaPdf;
      delete state.activity.mediaVid;
      delete state.activity.mediaCover;
      delete state.activity.isMine;

      state.activity.createdOn = new Date();
      state.activity.comments = 0;
      state.activity.likes = 0;
      state.activity.userId = firebase.auth().currentUser.uid;
      state.activity.userName = firebase.auth().currentUser.displayName;
      if (state.activity.draft) {
        state.activity.draft = false;
        await firebase.activitiesCollection
          .doc(state.activity.id)
          .update(Object.assign({}, state.activity));
      } else {
        await firebase.activitiesCollection.add(
          Object.assign({}, state.activity)
        );
      }
    },
    async saveDraft({ state, commit, rootGetters }) {
      (state.activity.cover = rootGetters["upload/getCoverUploaded"]
        ? rootGetters["upload/getCoverUploaded"]
        : ""),
        (state.activity.medias = rootGetters["upload/getMediasUploaded"]
          ? rootGetters["upload/getMediasUploaded"]
          : state.activity.medias),
        (state.activity.createdOn = new Date());
      state.activity.comments = 0;
      state.activity.likes = 0;
      state.activity.userId = firebase.auth().currentUser.uid;
      state.activity.userName = firebase.auth().currentUser.displayName;
      state.activity.draft = true;
      //clean
      delete state.activity._allMedia;
      delete state.activity.mediaPdf;
      delete state.activity.mediaVid;
      delete state.activity.mediaCover;
      delete state.activity.isMine;

      let libelleAge = ["Enfants"];

      if (
        state.activity.age === "3 à 6 ans" ||
        state.activity.age === "7 à 10 ans"
      ) {
        libelleAge = ["Enfants"];
      } else if (
        state.activity.age === "11 à 13 ans" ||
        state.activity.age === "14 à 17 ans"
      ) {
        libelleAge = ["Adolescents"];
      } else if (
        state.activity.age === "18 à 25 ans" ||
        state.activity.age === "26 à 40 ans"
      ) {
        libelleAge = ["Adultes jeunes"];
      } else if (state.activity.age === "41 à 65 ans") {
        libelleAge = ["Adultes d'âge moyen"];
      } else if (
        state.activity.age === "66 à 80 ans" ||
        state.activity.age === "81 ans et plus"
      ) {
        libelleAge = ["Adultes âgés"];
      } else if (state.activity.age === "18 ans et plus") {
        libelleAge = ["Adultes jeunes", "Adultes d'âge moyen", "Adultes âgés"];
      }

      state.activity.ageLibelle = libelleAge;
      state.activity.tags = [
        ...state.activity.proceduresUtilisees,
        state.activity.difficulte,
        ...state.activity.fonctionsCognitives,
        state.activity.typeIntervention,
        ...libelleAge
      ];

      if (state.activity.id) {
        await firebase.activitiesCollection
          .doc(state.activity.id)
          .update(Object.assign({}, state.activity));
      } else {
        await firebase.activitiesCollection
          .add(Object.assign({}, state.activity))
          .then(docRef => {
            state.activity.id = docRef.id;
          });
      }

      if (state.activity.cover) {
        const storageRefCover = firebase.storage.ref(state.activity.cover);
        storageRefCover.getDownloadURL().then(url => {
          if (url) {
            state.activity.mediaCover = { imageUrl: url };
          }
        });
      }

      commit("SET_ORIGINAL_ACTIVITY", state.activity);

      return state.activity.id;
    },
    async updateActivity({ state, rootGetters }, id) {
      state.activity = state.thisActivity;
      state.activity.titreUpper = state.activity.titre
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "")
        .toUpperCase();
      state.activity.descriptionUpper = state.activity.description
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "")
        .toUpperCase();
      //state.activity.proceduresUtiliseesUpper = state.activity.proceduresUtilisees.normalize("NFD").replace(/\p{Diacritic}/gu, "").toUpperCase();
      //state.activity.fonctionsCognitivesUpper = state.activity.fonctionsCognitives.normalize("NFD").replace(/\p{Diacritic}/gu, "").toUpperCase();

      //state.activity.cover = rootGetters["upload/getCoverUploaded"];
      state.activity.medias = rootGetters["upload/getMediasUploaded"];

      let libelleAge = ["Enfants"];

      if (
        state.activity.age === "3 à 6 ans" ||
        state.activity.age === "7 à 10 ans"
      ) {
        libelleAge = ["Enfants"];
      } else if (
        state.activity.age === "11 à 13 ans" ||
        state.activity.age === "14 à 17 ans"
      ) {
        libelleAge = ["Adolescents"];
      } else if (
        state.activity.age === "18 à 25 ans" ||
        state.activity.age === "26 à 40 ans"
      ) {
        libelleAge = ["Adultes jeunes"];
      } else if (state.activity.age === "41 à 65 ans") {
        libelleAge = ["Adultes d'âge moyen"];
      } else if (
        state.activity.age === "66 à 80 ans" ||
        state.activity.age === "81 ans et plus"
      ) {
        libelleAge = ["Adultes âgés"];
      } else if (state.activity.age === "18 ans et plus") {
        libelleAge = ["Adultes jeunes", "Adultes d'âge moyen", "Adultes âgés"];
      }

      state.activity.ageLibelle = libelleAge;

      delete state.activity._allMedia;
      delete state.activity.mediaCover;
      delete state.activity.isMine;
      delete state.activity.mediaPdf;
      delete state.activity.mediaImg;
      delete state.activity.mediaVid;

      const classification = Classification.getClassificationBySources(
        state.thisActivity.sourcesBibliographique
      );

      state.activity.classification = classification;
      state.activity.tags = [
        ...state.activity.proceduresUtilisees,
        classification,
        state.activity.difficulte,
        ...state.activity.fonctionsCognitives,
        state.activity.typeIntervention,
        ...libelleAge
      ];

      state.activity.updateOn = new Date();
      await firebase.activitiesCollection
        .doc(id)
        .update(Object.assign({}, state.activity));
    },
    async deleteActivity({ commit }, id) {
      if (id) {
        firebase.activitiesCollection.doc(id).delete();
        commit("SET_THIS_ACTIVITY", {});
      }
    },
    // eslint-disable-next-line no-unused-vars
    async getActivitiesByFilters(
      { commit },
      { filter, queryText, fonctionsCognitives, age, grade }
    ) {
      let req = firebase.activitiesCollection;
      //req = req.orderBy("_createdOn", "desc");
      if (filter) {
        if (queryText) {
          req = req
            .orderBy("_titreUpper")
            .orderBy("_createdOn", "desc")
            .where("_titreUpper", ">=", queryText.toUpperCase())
            .where("_titreUpper", "<=", queryText.toUpperCase() + "\uf8ff");
        }
        let arrayFilterSearch = [];
        if (age) {
          arrayFilterSearch.push(age);
        }
        if (fonctionsCognitives.length > 0) {
          for (const fonctionCog of fonctionsCognitives) {
            arrayFilterSearch.push(fonctionCog);
          }
        }
        if (grade) {
          req = req.where("_classification", "==", grade.value);
        }

        if (arrayFilterSearch.length > 0) {
          req = req.where("_tags", "array-contains-any", arrayFilterSearch);
        }
      } else {
        req = req.orderBy("_createdOn", "desc");
      }

      req
        .where("_disabled", "==", false)
        .where("_draft", "==", false)
        .onSnapshot(querySnapshot => {
          let activitiesArray = [];
          querySnapshot.forEach(activity => {
            const post = Object.assign(new Activity(), activity.data());
            post.id = activity.id;
            post.mainMedia = "";
            if (post.cover) {
              const storageRef = firebase.storage.ref(post.cover);
              storageRef.getDownloadURL().then(url => {
                post.mainMedia = url;
              });
            } else if (post.defaultCover) {
              const storageRef = firebase.storage.ref(post.defaultCover);
              storageRef.getDownloadURL().then(url => {
                post.mainMedia = url;
              });
            }

            activitiesArray.push(post);
          });
          commit("SET_ACTIVITIES", activitiesArray);
        });
    },
    // eslint-disable-next-line no-empty-pattern
    async favThis({}, id) {
      await firebase.usersCollection
        .doc(firebase.auth().currentUser.email)
        .update({
          fav: firebase.fieldValue.arrayUnion(id)
        });
    },
    // eslint-disable-next-line no-empty-pattern
    async unfavThis({}, id) {
      await firebase.usersCollection
        .doc(firebase.auth().currentUser.email)
        .update({
          fav: firebase.fieldValue.arrayRemove(id)
        });
    },
    // eslint-disable-next-line no-empty-pattern
    async likeThis({ rootState }, id) {
      await firebase.usersCollection
        .doc(firebase.auth().currentUser.email)
        .update({
          likes: firebase.fieldValue.arrayUnion(id)
        });
      if (rootState.user.user.likes) rootState.user.user.likes.push(id);
      await firebase.activitiesCollection.doc(id).update({
        _likes: firebase.fieldValue.increment(1)
      });
    },
    // eslint-disable-next-line no-empty-pattern
    async unlikeThis({ rootState }, id) {
      await firebase.usersCollection
        .doc(firebase.auth().currentUser.email)
        .update({
          likes: firebase.fieldValue.arrayRemove(id)
        });
      if (rootState.user.user.likes) delete rootState.user.user.likes[id];
      await firebase.activitiesCollection.doc(id).update({
        _likes: firebase.fieldValue.increment(-1)
      });
    }
  },
  mutations: {
    SET_THIS_ACTIVITY(state, data) {
      state.thisActivity = data;
    },
    SET_ORIGINAL_ACTIVITY(state, data) {
      state.originalActivity = JSON.parse(JSON.stringify(data));
    },
    SET_ACTIVITIES(state, data) {
      state.allActivities = data.sort(function(a, b) {
        if (a._createdOn < b._createdOn) {
          return 1;
        }
        if (a._createdOn > b._createdOn) {
          return -1;
        }

        return 0;
      });
    },
    SET_DRAFTS(state, data) {
      state.drafts = data;
    },
    SET_ACTIVITY(state, data) {
      state.activity = data;
    }
  }
};

export default ActivitiesModule;
